import { RefObject, createRef, useEffect, useState } from 'react'

export const useMultipleRef = <T>(length: number) => {
  const [elementRefs, setElementRefs] = useState<RefObject<T>[]>([])

  useEffect(() => {
    setElementRefs((elRefs) =>
      Array(length)
        .fill(undefined)
        .map((_, i) => elRefs[i] || createRef())
    )
  }, [length])

  return elementRefs
}
